"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.storeAsperaConnectId = exports.getUsersWorkgroups = exports.getUsersRemoteSources = exports.getUsersInteractions = exports.getUsers = exports.getUserMinimal = exports.getUser = exports.getTermsOfServiceAcceptance = exports.createUser = exports.checkRegistration = exports.acceptTermsOfService = void 0;
/* Package Imports */
var axios_1 = __importDefault(require("axios"));
/* Blast Imports */
var config_1 = require("@app/shared/config");
/* User API methods - BEGIN */
// Accept the terms of service
var acceptTermsOfService = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axios_1.default.post(config_1.Config.UI_SERVICES_URL + "/users/tos/accept")];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.acceptTermsOfService = acceptTermsOfService;
var checkRegistration = function (email) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axios_1.default.get(config_1.Config.UI_SERVICES_URL + "/users/register/check/" + email)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data];
        }
    });
}); };
exports.checkRegistration = checkRegistration;
// Create a new user
var createUser = function (request) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axios_1.default.post(config_1.Config.UI_SERVICES_URL + "/users/create", request)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.createUser = createUser;
// Check if terms of service have already been accepted
var getTermsOfServiceAcceptance = function () { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axios_1.default.get(config_1.Config.UI_SERVICES_URL + "/users/tos/accept")];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data];
        }
    });
}); };
exports.getTermsOfServiceAcceptance = getTermsOfServiceAcceptance;
// Retrieve a user, based on the provided email address - TODO-V5: not used, delete?
var getUser = function (email) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axios_1.default.get(config_1.Config.UI_SERVICES_URL + "/users/" + email)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data];
        }
    });
}); };
exports.getUser = getUser;
// Retrieve a user (w/ minimal data), based on the provided email address. Used primarily to determine if a user exists already.
var getUserMinimal = function (email) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axios_1.default.get(config_1.Config.UI_SERVICES_URL + "/users/" + email + "/exists", {
                    validateStatus: function (status) {
                        return status < 500;
                    }
                })];
            case 1:
                response = _a.sent();
                if (response.status !== 200) {
                    throw new Error("" + response.statusText);
                }
                return [2 /*return*/, response.data];
        }
    });
}); };
exports.getUserMinimal = getUserMinimal;
// Retrieve all users
var getUsers = function () { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axios_1.default.get(config_1.Config.UI_SERVICES_URL + "/users")];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data];
        }
    });
}); };
exports.getUsers = getUsers;
// Retrieve all interactions
var getUsersInteractions = function () { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axios_1.default.get(config_1.Config.UI_SERVICES_URL + "/users/interactions")];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data];
        }
    });
}); };
exports.getUsersInteractions = getUsersInteractions;
// Retrieve all shared folders (fka remote sources)
var getUsersRemoteSources = function () { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axios_1.default.get(config_1.Config.UI_SERVICES_URL + "/users/remote-sources")];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data];
        }
    });
}); };
exports.getUsersRemoteSources = getUsersRemoteSources;
// Retrieve all shared inboxes/workgroups
var getUsersWorkgroups = function () { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axios_1.default.get(config_1.Config.UI_SERVICES_URL + "/users/workgroups")];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data];
        }
    });
}); };
exports.getUsersWorkgroups = getUsersWorkgroups;
// Store the Aspera Connect id and version
var storeAsperaConnectId = function (connectId, connectVersion) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axios_1.default.post(config_1.Config.UI_SERVICES_URL + "/users/connect", { connectId: connectId, connectVersion: connectVersion })];
            case 1:
                response = _a.sent();
                if (response.data && response.data.jwt) {
                    return [2 /*return*/, response.data.jwt];
                }
                else {
                    throw new Error('unable to update jwt');
                }
                return [2 /*return*/];
        }
    });
}); };
exports.storeAsperaConnectId = storeAsperaConnectId;
/* User API methods - END */
